<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="case">
                        <div class="case-title">
                            <span>
                                1-库存充足-正常发货
                            </span>
                            <span>
                                NORMAL DELIVERY
                            </span>
                        </div>
                        <div class="case-content">
                            <img src="./../../assets/image/simulationCase/one.png" alt="">
                        </div>
                        <div class="case-foot" v-if="$store.state.record.caseIndex<=1"  @click="$router.push('/overseas-warehouses/checkAndRatify')">
                            模拟当前库存情况
                        </div>
                        <div class="case-foot finish" v-else >
                            已完成
                        </div>
                    </div>
                    <div class="case">
                        <div class="case-title">
                            <span>
                                2-库存充足、分散-申请移仓
                            </span>
                            <span>
                                SHIFT
                            </span>
                        </div>
                        <div class="case-content" style="background: #FBB521">
                            <img src="./../../assets/image/simulationCase/two.png" alt="">
                        </div>
                        <div class="case-foot" v-if="$store.state.record.caseIndex<=2"
                             @click="()=>{
                                 if(this.$store.state.record.caseIndex===2){
                                  this.$router.push('/overseas-warehouses/checkAndRatify')
                                 }
                             }">
                            模拟当前库存情况
                        </div>
                        <div class="case-foot finish" v-else >
                            已完成
                        </div>
                    </div>
                    <div class="case">
                        <div class="case-title">
                            <span>
                                3-库存不足-申请补仓
                            </span>
                            <span>
                                SUPPLEMENT
                            </span>
                        </div>
                        <div class="case-content" style="background: #9e9e9e">
                            <img src="./../../assets/image/simulationCase/three.png" alt="">
                        </div>
                        <div class="case-foot" v-if="$store.state.record.caseIndex<=3"
                             @click="()=>{
                                 if(this.$store.state.record.caseIndex===3){
                                  this.$router.push('/overseas-warehouses/checkAndRatify')
                                 }
                             }">
                            模拟当前库存情况
                        </div>
                        <div class="case-foot finish" v-else >
                            已完成
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">

            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "barCode",
        data() {
            return {

            }
        },
        computed:{
            product(){
                return this.$store.state.record.template.image
            }
        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px;

                .case {
                    margin-right: 60px;
                    position: relative;
                    &:before {
                        content: '';
                        position: absolute;
                        right: -54px;
                        top: 50%;
                        width: 0;
                        height: 0;
                        border-right: 16px solid transparent;
                        border-bottom: 16px solid transparent;
                        border-left: 16px solid #FBB521;
                        border-top: 16px solid transparent;

                    }
                    &:last-child:before {
                        display: none;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .case-title{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        margin-bottom: 10px;
                        span {
                            font-size: 18px;
                            font-weight: bolder;
                            &:last-child {
                                font-weight: normal;
                                font-size: 12px;
                            }
                        }
                    }
                    .case-content {
                        width: 312px;
                        height: 156px;
                        background: #5180FC;
                        border-radius: 10px;
                        position: relative;
                        margin-bottom: 10px;

                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                        }
                    }
                    .case-foot {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        border-radius: 10px;
                        background: #9e9e9e;
                        font-weight: bolder;
                        cursor: pointer;
                        font-size: 20px;
                        color: #FFFFFF;
                        transition: background-color 0.3s ease-in-out;
                        &.finish {
                            background: #42b983;
                        }
                        &:hover {
                            background: #5180FC;
                            transition: background-color 0.3s ease-in-out;
                        }
                    }
                }

            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
